import ButtonUI from '@/componentsUI/Button';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import PopupMask from '@/componentsUI/PopupMask';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonPopupProps } from './interface';

const CommonPopup = NiceModal.create((props: CommonPopupProps) => {
  const {rotate = false, ontentText = '', leftBtnText = '', rightBtnText = '', leftCallback, rightCallback, title = '', img = '' ,imgStyle} = props;

  const prefixCls = 'common-popup';

  const { visible, remove } = useModal();

  const { t } = useTranslation();

  const onClickOk = () => {
    remove();
  };


  return (
    <PopupMask visible={visible}>
      <div className={`${prefixCls}-body ${rotate ? prefixCls + '-rotate' : ''}`}>
        <div className={ img ? "message-img" : "message"}>
          <span className={'message-title'}>{title}</span>
          { img && (
            <img
              src={img}
              width="100%"
              className="img-content"
              style={{...imgStyle}}
              loading="lazy"
              alt=""
            />
          )}
          {ontentText && (<span className="message-text">{ontentText}</span>)}
        </div>
        <div className="btns">
          {leftBtnText && (
            <ButtonUI
              type={'secondary'}
              className={classNames(['btn', leftBtnText && !rightBtnText ? 'alone' : ''])}
              onClick={() => {
                leftCallback && leftCallback({ remove });
                !leftCallback && remove();
              }}
            >
              {leftBtnText}
            </ButtonUI>
          )}
          {rightBtnText && (
            <ButtonUI
              type={'primary'}
              className={classNames(['btn', !leftBtnText && rightBtnText ? 'alone' : ''])}
              onClick={() => {
                rightCallback && rightCallback({ remove });
                !rightCallback && remove();
              }}
            >
              {rightBtnText}
            </ButtonUI>
          )}
          {!leftBtnText && !rightBtnText && (
            <ButtonUI type={'primary'} className="btn alone" onClick={onClickOk}>
              {t('OK')}
            </ButtonUI>
          )}
        </div>
      </div>
    </PopupMask>
  );
});

export default CommonPopup;
